import TRTC from 'trtc-js-sdk';

export const initClient = ({ appID = 0, user = '', sig1 = '' }) => {
  return TRTC.createClient({
    mode: 'rtc',
    sdkAppId: appID,
    userId: user,
    userSig: sig1,
  });
};
export const joinRoom = (client: TRTC.Client, roomID = 0) => {
  return new Promise((res, rej) => {
    client
      .join({ roomId: roomID })
      .catch(error => {
        console.error('进房失败 ' + error);
      })
      .then(() => {
        console.log('进房成功');
      });
  });
};
